/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Close_Auto_Correct_Timing_ModalInputs */



/**
* | output |
* | --- |
* | "Close Auto Correct Timing Modal" |
*
* @param {Close_Auto_Correct_Timing_ModalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const close_auto_correct_timing_modal = /** @type {((inputs?: Close_Auto_Correct_Timing_ModalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Close_Auto_Correct_Timing_ModalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer la fenêtre de correction automatique")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatische Timingkorrektur schließen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiudi la finestra modale di correzione automatica dei tempi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Закрыть модальное окно автокоррекции времени")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cerrar el modo de sincronización de corrección automática")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("关闭自动校正计时模式")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動修正タイミングモーダルを閉じる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑटो करेक्ट टाइमिंग मॉडल बंद करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fechar Modal de Correção Automática de Tempo")
	return /** @type {LocalizedString} */ ("Close Auto Correct Timing Modal")
});